const batchFormMonitoredProperties: string[] = [
  'quantityToBeBatched',
  'driverName',
  'driverCode',
  'truckCode',
  'slump',
  'projectName',
  'projectCode',
  'customerName',
  'customerCode',
  'mixQuantityInTruck',
  'waterInTruck',
  'secondWater',
  'ice',
  'waterAdjust',
  'bay',
  'code',
];

export default batchFormMonitoredProperties;
